import React, { useCallback, useMemo } from 'react'

import { Container } from 'Components/Sections/EventDetailsDescription/Titles/TextRow/styles'
import { Text } from 'Components/UI'

import {
  DateGlyph,
  GolfFieldGlyph,
  LocationGlyph,
  PresenterGlyph,
} from 'Assets/Svg/Section/EventsList'

export enum EventsListGalleryCardTextRowKind {
  Date = 'date',
  Name = 'name',
  Presenter = 'presenter',
  Address = 'address',
}

type Props = {
  clickable?: boolean
  kind: EventsListGalleryCardTextRowKind
  text?: string
  onClick?: () => void
}

function EventDetailsDescriptionTextRow({
  clickable,
  kind,
  text,
  onClick,
}: Props) {
  const icon = useMemo(() => {
    switch (kind) {
      case EventsListGalleryCardTextRowKind.Date:
        return DateGlyph
      case EventsListGalleryCardTextRowKind.Name:
        return GolfFieldGlyph
      case EventsListGalleryCardTextRowKind.Presenter:
        return PresenterGlyph
      default:
        return LocationGlyph
    }
  }, [kind])

  const handleClick = useCallback(() => {
    if (!clickable) return

    onClick?.()
  }, [clickable, onClick])

  if (!text) return null

  return (
    <Container clickable={clickable} onClick={handleClick}>
      {icon()}

      <Text accent={clickable} important={!clickable} medium screen18>
        {text}
      </Text>
    </Container>
  )
}

export default EventDetailsDescriptionTextRow
